<template>
  <v-card class="text-xs-center ">
    <v-card class="d-flex">
      <div
        style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        height: 50px;
      "
      >
        <img
          src="@/assets/back-office/icons/chevron_icon_left.svg"
          alt=""
          width="30px"
          @click="$router.back()"
          style="cursor: pointer; margin-left:1vw"
        />
        <h2 class="text-xs-center">
          Transaction ({{ this.$route.params.user_partner_first_name }}
          {{ this.$route.params.user_partner_last_name }})
        </h2>
        <div></div>
      </div>
    </v-card>
    <userTable />
  </v-card>
</template>

<script>
import userTable from "@/components/back-office/ManagerUserManage/TransactionTable.vue";
import { mapState } from "vuex";
export default {
  components: {
    userTable,
  },
  computed: {
    ...mapState({
      recentPath: (state) => state.backOffice.recentRoutePath,
    }),
  },
  destroyed() {
    this.$store.commit("fetchUserBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Manager management",
        disabled: true,
        href: "/weserve_admin_login/control/-/manager-manage",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style></style>
